const canUseDOM = !!(typeof window < "u" && window.document && window.document.createElement);
var canUseDOM_default = canUseDOM;
export { canUseDOM, canUseDOM_default as default };
//# sourceMappingURL=canUseDOM.mjs.map
